// The Inventory board on the Fleetio feed, beside the file feed's until it is
// proven (pages/InventoryCompare.jsx).
import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import Inventory from './Inventory';
import { FLEETIO_FEED, InventorySourceProvider } from '../components/Inventory/InventorySource';
import { c, sp, t } from '../theme';

const linkStyle = { ...t.bodySm, fontWeight: 600, color: c.navy, background: c.surface, border: `1px solid ${c.border}`, borderRadius: '8px', padding: `${sp[2]} ${sp[3]}`, textDecoration: 'none', display: 'inline-block' };

export default function InventoryFleetio() {
  const source = useMemo(() => ({
    ...FLEETIO_FEED,
    headerLink: <Link to="/inventory-fleetio/compare" style={linkStyle}>Compare with Inventory</Link>,
  }), []);
  return (
    <InventorySourceProvider value={source}>
      <Inventory />
    </InventorySourceProvider>
  );
}
